<template>
  <section class="content">
    <div>
      <div id="overlay" v-if="loading">
        <div class="spinner"></div>
        <br/>
        <h4>Loading...</h4>
      </div>
      <div class="box box-info">
        <form>
          <div class="p-fluid p-formgrid p-grid">
            <div class="p-field p-col-12 p-md-2">
              <label for="fromDate">As on Date</label>
              <date-picker v-model="toDate" valueType="format" v-if="!englishDateEnabled"/>
              <input-mask mask="9999-99-99" type="text" v-else class="nepali-calendar" id="toDate" v-model="toDate"/>
            </div>

            <div class="p-field p-col-12 p-md-1 p-mt-5">
              <Button type="submit" @click.prevent="searchReport"
                      class="p-button-raised" label="Search" icon="pi pi-search"/>
              <!-- <button type="submit" style="margin-left:10px" v-if="this.inventoryClosingStockLists.length > 0"  @click.prevent="reset"
             class="btn btn-info pull-left">Reset</button> -->
            </div>
          </div>
        </form>
        <div class="p-fluid p-formgrid p-grid">
          <a href="#" @click.prevent="exportCSV()" v-if="this.inventoryClosingStockLists.length > 0">
              <img src="../../../../static/img/excel.png" style="float:right;height: 3em;width: 3em;"/>
            </a>
          <div class="p-field p-col-12 p-col-12">
            
            <DataTable :value="inventoryClosingStockLists"
                       :paginator="true" ref="po"
                       :rowsPerPageOptions="[100,500,1000]"
                       :rows="100" :filters="filters"
                       class="p-datatable-responsive p-datatable-gridlines"
                       data-key="id">
              <Column header="S.N">
                <template #body="sl">
                  {{ sl.index + 1 }}
                </template>
              </Column>
              <Column header="Item Name" :sortable="true" field="itemName" filterMatchMode="contains">
                <template #filter>
                  <InputText type="text" class="p-column-filter" v-model="filters['itemName']"/>
                </template>
              </Column>
              <Column header="Item Code" :sortable="true" field="itemCode" filterMatchMode="contains">
                <template #filter>
                  <InputText type="text" class="p-column-filter" v-model="filters['itemCode']"/>
                </template>
              </Column>

              <Column header="Qty" :sortable="true" field="closingQuantity" filterMatchMode="contains">
                <template #filter>
                  <InputText type="text" class="p-column-filter" v-model="filters['closingQuantity']"/>
                </template>
              </Column>
              <Column header="Unit" :sortable="true" field="unit" filterMatchMode="contains">
                <template #filter>
                  <InputText type="text" class="p-column-filter" v-model="filters['unit']"/>
                </template>
              </Column>
              <Column header="Purchase Rate" :sortable="true" field="price" filterMatchMode="contains">
                <template #filter>
                  <InputText type="text" class="p-column-filter" v-model="filters['price']"/>
                </template>
              </Column>
              <Column header="Sales Rate" :sortable="true" field="sellingRate" filterMatchMode="contains">
                <template #filter>
                  <InputText type="text" class="p-column-filter" v-model="filters['sellingRate']"/>
                </template>
              </Column>
              <Column header="Amount" :sortable="true" field="closingValue" filterMatchMode="contains">
                <template #filter>
                  <InputText type="text" class="p-column-filter" v-model="filters['closingValue']"/>
                </template>
              </Column>
<!--              <Column header="Action">-->
<!--                <template #body="slotProps">-->
<!--                  <Button class="p-button-raised" @click="viewPIVDetail(slotProps.data)"-->
<!--                          icon="pi pi-eye"/>-->
<!--                </template>-->
<!--              </Column>-->
              <template #empty>No record found</template>
              <ColumnGroup type="footer">
                <Row>
                  <Column footer="Totals:" :colspan="3" footerStyle="text-align:right"/>
                  <Column :footer="totalQty" />
                  <Column :colspan="3"/>
                  <Column :footer="totalAmount" :colspan="1"/>
                </Row>
              </ColumnGroup>
            </DataTable>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>
<script>
import DatePicker from 'vue2-datepicker'
import DataTable from 'primevue/datatable'
import Column from 'primevue/column'
import globalKey from '../../../store/globalKey'
import axios from 'axios'
import $ from 'jquery'
import InputText from 'primevue/inputtext'
import InputMask from 'primevue/inputmask'
import Button from 'primevue/button'
import ColumnGroup from 'primevue/columngroup'
import Row from 'primevue/row'

export default {
  name: 'inventoryClosingStockLists',
  data() {
    return {
      toDate: null,
      formatted_date: '',
      inventoryClosingStockLists: [],
      loading: false,
      columnList: '',
      filters: {},
      englishDateEnabled: true,
      totalQty: 0,
      totalAmount: 0
    }
  },
  mounted() {
    this.checkEnglish()
    if (!this.$store.getters.englishDate || this.$store.state.isEnglishDateEnabled === 'false') {
      this.nepaliDate()
    }
    if (!this.$store.getters.englishDate && this.salesChallan === undefined ||
      this.$store.state.isEnglishDateEnabled === 'false') {
      this.setNepaliDate()
    }
    if (this.$store.state.isEnglishDateEnabled && this.$store.state.isEnglishDateEnabled !== 'false') {
      this.setEnglishDate()
    }
    this.columnNames()
  },
  methods: {
    async searchReport() {
      let dat = {
        toDate: this.toDate
      }
      this.loading = true
      let resp = await this.$store.dispatch('loadInventoryClosingStock', dat)
      this.loading = false
      this.inventoryClosingStockLists = resp.data.data
      this.$toast.add({severity: 'success', summary: '', detail: resp.data.message, life: 3000})
      this.returnTotalQty()
    },
    returnTotalQty() {
      this.totalQty = this.inventoryClosingStockLists[this.inventoryClosingStockLists.length - 1].totalClosingStockSum
      this.totalAmount = this.inventoryClosingStockLists[this.inventoryClosingStockLists.length - 1].totalClosingAmount
    },
    exportCSV() {
      let data = {
        toDate: this.toDate,
        columnList: this.columnList
      }
      axios({
        url: globalKey + '/fileDownload/excelReportInventory/' + 0 + '/' + this.$store.getters.organisationId + '/' + this.$store.getters.userId + '/' + data.toDate + '/' + data.toDate + '/Inventory Closing Stock' + '/' + this.$store.getters.fyId + '/' + data.columnList,
        method: 'get',
        headers: {'Accept': 'application/vnd.ms-excel', 'Authorization': localStorage.token},
        responseType: 'blob'
      }).then((response) => {
        const url = window.URL.createObjectURL(new Blob([response.data]), {type: response.data.type})
        const link = document.createElement('a')
        const contentDisposition = response.headers['content-disposition']
        let fileName = 'ClosingStcokReport.xlsx'
        if (contentDisposition) {
          const fileNameMatch = contentDisposition.match(/filename="(.+)"/)
          if (fileNameMatch.length === 2) {
            fileName = fileNameMatch[1]
          }
        }
        link.href = url
        link.setAttribute('download', fileName)
        document.body.appendChild(link)
        link.click()
        link.remove()
        window.URL.revokeObjectURL(url)
      })
    },
    columnNames() {
      for (let i = 0; i < this.$refs.po.columns.length; i++) {
        this.columnList += this.$refs.po.columns[i].header + ','
      }
    },
    reset() {
      this.inventoryClosingStockLists = []
      if (!this.$store.getters.englishDate || this.$store.state.isEnglishDateEnabled === 'false') {
        this.toDate = this.$store.getters.nepaliNewDate
      } else {
        this.toDate = new Date().toISOString().slice(0, 10)
      }
    },
    setNepaliDate() {
      if (this.$store.getters.nepaliNewDate !== '') {
        this.toDate = this.$store.getters.nepaliNewDate
      }
    },
    setEnglishDate() {
      this.toDate = new Date().toISOString().slice(0, 10)
    },
    checkEnglish() {
      if (this.$store.state.isEnglishDateEnabled === false || this.$store.state.isEnglishDateEnabled === 'false') {
        this.englishDateEnabled = true
        return
      } else {
        this.englishDateEnabled = false
        return
      }
    },
    nepaliDate() {
      $('#toDate').nepaliDatePicker({
        ndpYear: true,
        ndpMonth: true,
        ndpYearCount: 10,
        disableBefore: this.$store.state.startDate,
        disableAfter: this.$store.state.endDate,
        onChange: () => {
          this.toDate = $('#toDate').val()
        }
      })
    }
  },
  components: {
    DatePicker,
    DataTable,
    Column,
    InputText,
    InputMask,
    Button,
    ColumnGroup,
    Row
  }
}
</script>
<style scoped src="@../../../static/css/purchase.css">

</style>



// WEBPACK FOOTER //
// closingStock.vue?53d4ca34